<script setup lang="ts">
import { useRouter } from "vue-router";
import { useAuth } from "@/utils/authentication";

const auth = useAuth();
const { status, message, isLoading } = auth;
const router = useRouter();
const retry = async () => {
  if (["signInFailed", "signedOut", "noOrganization"].includes(status.value))
    await auth.signIn();
  else await auth.initialize();
};
</script>

<template>
  <main
    class="min-vh-100 d-flex flex-column justify-content-center align-items-center gap-3"
  >
    <p role="status">
      {{
        isLoading
          ? "Completing sign-in..."
          : status === "signedOut"
            ? "Sign in to continue."
            : message
      }}
    </p>
    <template v-if="!isLoading">
      <button class="btn btn-primary" @click="retry">Try again</button>
      <button
        class="btn btn-outline-secondary"
        @click="router.push({ name: 'Logout' })"
      >
        Sign out
      </button>
    </template>
  </main>
</template>
